<template>
  <v-container
    id="dashboard-view"
    fluid
    tag="section"
  >
  <v-row>
    <!-- Left Panel: Event Details and Actions -->
    <v-col cols="12" md="4" class="pa-4" style="border-right: 1px solid #eee; min-height: 80vh;">
      <v-card outlined>
        <v-card-title>
          Szczegóły zdarzenia
        </v-card-title>
        <v-card-text>
          <!-- Example event details -->
          <div><strong>ID:</strong> #12345</div>
          <div><strong>Typ:</strong> Alarm</div>
          <div><strong>Czas:</strong> 2024-06-10 14:23</div>
          <div><strong>Lokalizacja:</strong> Warszawa, ul. Przykładowa 1</div>
          <div><strong>Status:</strong> W trakcie obsługi</div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="d-flex flex-column align-start">
          <v-btn color="primary" class="mb-2" block>Wyślij patrol</v-btn>
          <v-btn color="success" class="mb-2" block>Zamknij zdarzenie</v-btn>
          <v-btn color="error" block>Zgłoś problem</v-btn>
        </v-card-actions>
      </v-card>
    </v-col>

    <!-- Right Panel: Patrol Status and Timeline -->
    <v-col cols="12" md="8" class="pa-4">
      <!-- Patrol Status -->
      <v-card outlined class="mb-4">
        <v-card-title>
          Status patroli
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="6" sm="4" v-for="(patrol, idx) in 3" :key="idx">
              <v-chip color="success" text-color="white" class="ma-1">
                Patrol #{{ idx + 1 }}: W drodze
              </v-chip>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <!-- Timeline (iMessage style) -->
      <v-card outlined style="height: 60vh; overflow-y: auto;">
        <v-card-title>
          Timeline zdarzenia
        </v-card-title>
        <v-card-text>
          <div class="d-flex flex-column" style="gap: 16px;">
            <div class="d-flex" style="justify-content: flex-start;">
              <v-sheet color="grey lighten-3" rounded class="pa-3" max-width="70%">
                <div><strong>Operator:</strong> Zgłoszenie przyjęte</div>
                <div class="text-caption grey--text">14:23</div>
              </v-sheet>
            </div>
            <div class="d-flex" style="justify-content: flex-end;">
              <v-sheet color="blue lighten-4" rounded class="pa-3" max-width="70%">
                <div><strong>Patrol:</strong> Wyruszamy na miejsce</div>
                <div class="text-caption grey--text text-right">14:25</div>
              </v-sheet>
            </div>
            <div class="d-flex" style="justify-content: flex-start;">
              <v-sheet color="grey lighten-3" rounded class="pa-3" max-width="70%">
                <div><strong>Operator:</strong> Proszę o potwierdzenie przyjazdu</div>
                <div class="text-caption grey--text">14:30</div>
              </v-sheet>
            </div>
            <!-- Add more timeline items as needed -->
          </div>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
  </v-container>
</template>

<script>
  // Utilities
  import { get } from 'vuex-pathify'
  import Vue from 'vue'

  const lineSmooth = Vue.chartist.Interpolation.cardinal({
    tension: 0,
  })

  export default {
    name: 'DashboardExample',

    data: () => ({
      countryData: {
        US: 2920,
        DE: 1390,
        AU: 760,
        GB: 690,
        RO: 600,
        BR: 550,
      },
      charts: [{
        type: 'Bar',
        color: 'primary',
        title: 'Website Views',
        subtitle: 'Last Campaign Performance',
        time: 'updated 10 minutes ago',
        data: {
          labels: ['Ja', 'Fe', 'Ma', 'Ap', 'Mai', 'Ju', 'Jul', 'Au', 'Se', 'Oc', 'No', 'De'],
          series: [
            [542, 443, 320, 780, 553, 453, 326, 434, 568, 610, 756, 895],
          ],
        },
        options: {
          axisX: {
            showGrid: false,
          },
          low: 0,
          high: 1000,
          chartPadding: {
            top: 0,
            right: 5,
            bottom: 0,
            left: 0,
          },
        },
        responsiveOptions: [
          ['screen and (max-width: 640px)', {
            seriesBarDistance: 5,
            axisX: {
              labelInterpolationFnc: function (value) {
                return value[0]
              },
            },
          }],
        ],
      }, {
        type: 'Line',
        color: 'success',
        title: 'Daily Sales',
        subtitle: '<i class="mdi mdi-arrow-up green--text"></i><span class="green--text">55%</span>&nbsp;increase in today\'s sales',
        time: 'updated 4 minutes ago',
        data: {
          labels: ['12am', '3pm', '6pm', '9pm', '12pm', '3am', '6am', '9am'],
          series: [
            [230, 750, 450, 300, 280, 240, 200, 190],
          ],
        },
        options: {
          lineSmooth,
          low: 0,
          high: 1000, // creative tim: we recommend you to set the high sa the biggest value + something for a better look
          chartPadding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
          },
        },
      }, {
        type: 'Line',
        color: 'info',
        title: 'Completed Tasks',
        subtitle: 'Last Campaign Performance',
        time: 'campaign sent 26 minutes ago',
        data: {
          labels: ['M', 'T', 'W', 'T', 'F', 'S', 'S'],
          series: [
            [12, 17, 7, 17, 23, 18, 38],
          ],
        },
        options: {
          lineSmooth,
          low: 0,
          high: 50, // creative tim: we recommend you to set the high sa the biggest value + something for a better look
          chartPadding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
          },
        },
      }],
      listings: [
        {
          image: 2,
          location: 'Barcelona, Spain',
          price: '$899/night',
          text: 'The place is close to Barceloneta Beach and bus stop just 2 min by walk and near to "Naviglio" where you can enjoy the life in Barcelona.',
          title: 'Cozy 5 Stars Apartment',
        },
        {
          image: 3,
          location: 'Office Studio',
          price: '$1.119/night',
          text: 'The place is close to Metro Station and bus stop just 2 min by walk and near to "Naviglio" where you can enjoy the night life in London, UK.',
          title: 'Office Studio',
        },
        {
          image: 1,
          location: 'Milan, Italy',
          price: '$459/night',
          text: 'The place is close to Metro Station and bus stop just 2 min by walk and near to "Naviglio" where you can enjoy the main night life in Milan.',
          title: 'Beautiful Castle',
        },
      ],
      stats: [
        {
          actionIcon: 'mdi-alert',
          actionText: 'Get More Space...',
          color: '#FD9A13',
          icon: 'mdi-sofa-single',
          title: 'Bookings',
          value: '184',
        },
        {
          actionIcon: 'mdi-tag',
          actionText: 'Tracked from Google Analytics',
          color: 'primary',
          icon: 'mdi-chart-bar',
          title: 'Website Visits',
          value: '75.521',
        },
        {
          actionIcon: 'mdi-calendar-range',
          actionText: 'Last 24 Hours',
          color: 'success',
          icon: 'mdi-store',
          title: 'Revenue',
          value: '$34,245',
        },
        {
          actionIcon: 'mdi-history',
          actionText: 'Just Updated',
          color: 'info',
          icon: 'mdi-twitter',
          title: 'Followers',
          value: '+245',
        },
      ],
    }),

    computed: {
      sales: get('sales/sales'),
      totalSales () {
        return this.sales.reduce((acc, val) => acc + val.salesInM, 0)
      },
    },
  }
</script>
